module.exports = fox._r("images/header-menu-icons.png", __webpack_public_path__ + "_/_/_/common/frame/images/header-menu-icons.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/images/header-menu-icons.png
// module id = 123
// module chunks = 2